export enum VerifyType {
  Verified = 1,
  New = 2,
  Waiting = 3,
  Unverified = 4,
}
